<template>
  <div v-if="!loading" class="container">
    <van-swipe class="my-swipe" :autoplay="5000">
      <van-swipe-item
        v-for="item in swipeList"
        :key="item.ID"
        @click="toLink(item.IMAGE_LINK)"
      >
        <img :src="item.IMAGE_URL" alt>
      </van-swipe-item>
    </van-swipe>
    <van-dropdown-menu>
      <van-dropdown-item
        v-model="yt"
        :options="ytList"
        @change="onChangeYt()"
      />
      <van-dropdown-item
        v-model="store"
        :options="storeList"
        @change="onChangeStore()"
      />
    </van-dropdown-menu>
    <div class="listBox">
      <van-list
        :loading="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-collapse v-model="activeCollapseItem" accordion :border="false">
          <van-collapse-item
            v-for="item in recruitPostList"
            :key="item.ID"
            :name="item.ID"
            title-class="collapseTitle"
            label-class="collapseLabel"
            :border="false"
          >
            <template #icon>
              <div class="back" />
              <div class="backImg" />
            </template>
            <template #title>
              <van-tag color="#da0b66">{{ item.POST_NAME }}</van-tag>
            </template>
            <template #label>
              <van-icon
                name="location-o"
                size="15px"
              ><span class="text">{{ item.REGION }}</span></van-icon>
              <br>
              <van-icon
                name="shop-o"
                size="15px"
              ><span class="text">{{ item.ORGAN_NAME }}</span></van-icon>
            </template>
            <div class="require">
              <h4>工作职责</h4>
              <p v-for="(r, i) in item.RESPON.split('_r_n')" :key="i">
                {{ r.length === 0 ? "无" : r }}
              </p>
            </div>
            <div class="respon">
              <h4>岗位要求</h4>
              <p v-for="(r, i) in item.REQUIRE.split('_r_n')" :key="i">
                {{ r.length === 0 ? "无" : r }}
              </p>
            </div>
            <van-button
              v-show="!showButton"
              block
              color="#da0b66"
              type="primary"
              icon="envelop-o"
              style="margin-top: 16px"
              size="small"
              @click="
                toFillResume(
                  item.ORGAN_TOP,
                  item.ORGAN_ID,
                  item.POST,
                  item.ORGAN_NAME,
                  item.JOBTYPE
                )
              "
            >申请岗位
            </van-button>
          </van-collapse-item>
        </van-collapse>
      </van-list>
    </div>
    <div
      v-show="showSurvey"
      style="
        float: right;
        margin-right: 1em;
        position: fixed;
        bottom: 5.5em;
        right: 3px;
      "
    >
      <van-button
        icon="edit"
        size="laryz"
        style="
          width: 2.5em;
          height: 2.5em;
          background-color: #da0b66;
          color: #fff;
          opacity: 0.8;
          font-weight: 800;
          border-radius: 2.5em;
          line-height: 14px;
        "
        @click="toMySurvey"
      />
      <p
        style="font-size: 0.8rem; font-weight: 800; opacity: 0.6; margin: 5px 0"
      >
        测试问卷
      </p>
    </div>
    <div
      v-show="showButton"
      style="
        float: right;
        margin-right: 1em;
        position: fixed;
        bottom: 3px;
        right: 3px;
      "
    >
      <van-button
        icon="user-o"
        size="laryz"
        style="
          width: 2.5em;
          height: 2.5em;
          background-color: #da0b66;
          color: #fff;
          opacity: 0.8;
          font-weight: 800;
          border-radius: 2.5em;
          line-height: 14px;
        "
        @click="toMyResume"
      />
      <p
        style="font-size: 0.8rem; font-weight: 800; opacity: 0.6; margin: 5px 0"
      >
        {{ resumeStatus === "10" ? "待完善简历" : "我的简历" }}
      </p>
    </div>
    <!-- 招聘渠道选择 -->
    <van-dialog
      v-model:show="showJobTypeSelection"
      width="50%"
      :show-confirm-button="false"
    >
      <div style="padding: 30px">
        <van-radio-group
          v-model="jobtype"
          checked-color="#da0b66"
          direction="vertical"
          @change="setJobType"
        >
          <van-radio style="padding: 5px 0" name="0">社会招聘</van-radio>
          <van-radio style="padding: 5px 0" name="1">校园招聘</van-radio>
          <van-radio style="padding: 5px 0" name="2">员工招聘</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {
  getRegionList,
  getStoreList,
  getRecruitPostList,
  getResume,
  getSwipe
} from '@/api/api.js'
import { Dialog } from 'vant'

export default {
  data() {
    return {
      loading: false,
      finished: false,
      regionList: [],
      ytList: [
        { text: '业态', value: '0' },
        { text: '百货', value: '02' },
        { text: '超市', value: '03' }
      ],
      storeList: [],
      recruitPostList: [],
      swipeList: [],
      activeCollapseItem: '',
      store: '0',
      region: '4115',
      jobtype: sessionStorage.getItem('jobtype'),
      channel: '',
      showButton: false,
      showSurvey: false,
      showJobTypeSelection: false,
      resumeStatus: '',
      yt: '02'
    }
  },
  created() {
    if (this.$route.query.openid && this.$route.query.token) {
      sessionStorage.setItem('openid', this.$route.query.openid)
      sessionStorage.setItem('token', this.$route.query.token)
      if (this.$route.query.jobtype) {
        sessionStorage.setItem('jobtype', this.$route.query.jobtype)
        this.jobtype = this.$route.query.jobtype
      }
      if (this.$route.query.company) {
        sessionStorage.setItem('company', this.$route.query.company)
        this.yt = sessionStorage.getItem('company')
      }
      this.$router.push('/')
    }
    if (
      sessionStorage.getItem('jobtype') === null ||
      sessionStorage.getItem('jobtype') === ''
    ) {
      this.showJobTypeSelection = true
    }
    this.init()
  },
  methods: {
    init() {
      const toast = this.$toast.loading({
        message: '正在加载',
        forbidClick: true,
        loadingType: 'spinner'
      })
      this.loading = true
      setTimeout(async() => {
        // this.getRegionList();
        this.getStoreList()
        this.getRecruitPostList(this.yt, this.store, this.jobtype)
        getResume({ openid: sessionStorage.getItem('openid') }).then(
          (response) => {
            const res = response.data
            this.resumeStatus = res.data.STATUS
            if (res.data) {
              this.showButton = true
            }
          }
        )
        this.getSwipe()
        this.loading = false
        this.finished = true
        await toast.clear()
      }, 1000)
    },
    setJobType(jobType) {
      this.jobtype = jobType
      sessionStorage.setItem('jobtype', jobType)
      this.init()
      this.showJobTypeSelection = false
    },
    onChangeYt() {
      this.getRecruitPostList(this.yt, this.store, this.jobtype)
      // this.getStoreList(this.region);
    },
    onChangeStore() {
      this.getRecruitPostList(this.yt, this.store, this.jobtype)
    },
    getRegionList() {
      getRegionList().then((response) => {
        const res = response.data
        if (res.code === 200) {
          this.regionList.push({ text: '全部', value: '0' })
          res.data.forEach((item) => {
            this.regionList.push({ text: item.REGION, value: item.CODE })
          })
        }
      })
    },
    getStoreList() {
      getStoreList().then((response) => {
        const res = response.data
        if (res.code === 200) {
          this.storeList = []
          this.storeList.push({ text: '门店/单位', value: '0' })
          res.data.forEach((item) => {
            this.storeList.push({ text: item.CNAME, value: item.CNAME })
          })
        }
      })
      this.store = '0'
    },
    getRecruitPostList(yt, store, jobtype) {
      getRecruitPostList({
        yt: yt === '0' ? '' : yt,
        store: store === '0' ? '' : store,
        jobtype: jobtype
      }).then((response) => {
        const res = response.data
        if (res.code === 200) {
          this.recruitPostList = []
          this.recruitPostList = res.data
        }
      })
    },
    getSwipe() {
      getSwipe().then((response) => {
        const res = response.data
        if (res.code === 200) {
          this.swipeList = res.data
        }
      })
    },
    toFillResume(organ, depart, post, cname, jobtype) {
      Dialog.confirm({
        title: '投递确认',
        message: '您所投递的岗位仅适用于' + cname + '，请确认是否合适！'
      })
        .then(() => {
          this.$router.push({
            path: '/fillResume',
            query: {
              organ: organ,
              depart: depart,
              post: post,
              jobtype: jobtype
            }
          })
        })
        .catch(() => {})
    },
    toMyResume() {
      this.$router.push({ path: '/myResume' })
    },
    toLink(link) {
      window.location.href = link
    },
    toMySurvey() {
      this.$router.push.push({ path: '/testSurvey' })
    }
  }
}
</script>

<style scoped>
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}

::v-deep .collapseTitle {
  text-align: left;
  font-size: 1em;
}

::v-deep .collapseLabel .text {
  margin-left: 5px;
  width: 10em;
  font-size: 0.8em !important;
}

.require p {
  margin: 0;
  padding: 0;
  text-align: left;
}

.require h4 {
  margin: 0.5em 0;
  padding: 0;
  text-align: left;
  color: #da0b66;
}

.respon p {
  margin: 0;
  padding: 0;
  text-align: left;
}

.respon h4 {
  margin: 0.5em 0;
  padding: 0;
  text-align: left;
  color: #da0b66;
}

.listBox {
  height: 80vh;
  overflow: scroll;
}

::v-deep .van-collapse {
  margin: 1em;
  box-shadow: 0 2px 12px rgb(100 101 102 / 12%);
}

::v-deep .van-swipe-item {
  height: 8em;
}

::v-deep .van-swipe-item img {
  width: 100%;
}

::v-deep .van-dropdown-menu__title {
  font-weight: 600;
}

::v-deep .van-cell__title {
  margin-left: 1%;
  padding: 0 5px 0 5px;
  width: 20em;
  font-weight: 600;
  position: relative;
}

::v-deep .van-cell__label {
  width: 20em;
}

.back {
  width: 85%;
  height: 5em;
  background: #da0b66;
  position: absolute;
  opacity: 0.05;
  border-top-right-radius: 3em;
}

.backImg {
  background: url(/XiYaLogo.png) no-repeat;
  width: 5em;
  height: 4em;
  position: absolute;
  bottom: 12%;
  right: 12%;
  background-size: 5em 4em;
  opacity: 0.2;
}
</style>
